import { action, observable, makeObservable } from 'mobx'

class ReferenceCache {
  cache = observable.map({}, { deep: false })

  constructor () {
    makeObservable(this, {
      add: action
    })
  }

  add (...args) {
    const val = args.pop()
    if (!args.some(a => a == null || !a.length)) {
      this.cache.set(args.join('-'), val)
    }
  }

  addIfNew (...args) {
    const val = args.pop()
    if (!this.get(...args)) {
      this.add(...args, val)
    }
  }

  get (...keys) {
    return this.cache.get(keys.join('-'))
  }
}

export const refCache = new ReferenceCache()
